import { render, staticRenderFns } from "./PmtaRelayGroups.vue?vue&type=template&id=2d4d7438&scoped=true"
import script from "./PmtaRelayGroups.vue?vue&type=script&lang=js"
export * from "./PmtaRelayGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d7438",
  null
  
)

export default component.exports